namespace $.$$ {
	$mol_style_define( $shm_hitalama_map_widget_float_table_resize, {
		position: 'absolute',
		top: 0,
		bottom: 0,
		right: '-2px',
		width: '4px',
		zIndex: 3,
		pointerEvents: 'auto',
		cursor: 'col-resize',
		touchAction: 'none',
		userSelect: 'none',
		':hover': { background: { color: 'black' } },
	} )
}
